export const fetch_folders = () => {
    var url = global.config.server_path+'folder/get';        
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include'})
}

export const delete_folder = (folder_id) => {
    const url = global.config.server_path+'folder/delete'
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({folder_id: folder_id})})
    .then(data => {
        return Promise.resolve('successfully deleted folder.')
    })
    .catch(err => Promise.reject(err))
}

export const rename_folder = (folder_id, new_name) => {
    const url = global.config.server_path+'folder/rename'
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({folder_id: folder_id, 'new_name': new_name})})
    .then(data => {
        return Promise.resolve('successfully renamed.')
    })
    .catch(err => Promise.reject(err))
}

export const fetch_designs = () => {
    const url = global.config.server_path+'saved_design/get_all';
    return fetch (url, {method : 'GET', 'credentials': 'include'})
}

export const delete_folder_resource = (folder_id, resource) => {
    const url = global.config.server_path+'folder/delete_resource'
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({folder_id: folder_id, resource : resource})})
    .then(data => {
        return Promise.resolve('successfully deleted folder resource.')
    })
    .catch(err => Promise.reject(err))    
}
